import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MapsAPILoader } from "@agm/core";

@Component({
  selector: 'app-googlemapsdx',
  templateUrl: './googlemapsdx.component.html',
  styleUrls: ['./googlemapsdx.component.scss']
})
export class GooglemapsdxComponent implements OnInit {
  constructor(private mapsAPILoader: MapsAPILoader, private ngZone: NgZone,
   ) {
      this.mapsAPILoader.load().then(() => {
        this.geoCoder = new google.maps.Geocoder();
  
        let autocomplete = new google.maps.places.Autocomplete(
          this.searchElementRef.nativeElement as HTMLInputElement
        );
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
  
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
  
            this.latitude = place.geometry.location.lat();
  
            this.longitude = place.geometry.location.lng();
            this.getAddress(this.latitude, this.longitude);
            this.zoom = 12;
            this.isValidAddress.emit(true);
          
          });
        });
      });
  }

  onLocationChanged() {
    this.isValidAddress.emit(false);
  }

  // Maps
  title: string = "AGM project";
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;

  googleAddress;
  isValidLocation = false;


  @ViewChild("search", { static: true })
  public searchElementRef: ElementRef;

  //maps

  @Output("googleAddress") googleAddressOutput = new EventEmitter<Object>();
  @Output("isValidAddress") isValidAddress = new EventEmitter<Object>();
  @Input("showAddress") showGoogleAddress : any;
  @Input("mode") mode : any;

  ngOnInit() {  //maps
   console.log(this.mode);
   console.log(this.showGoogleAddress);
    //maps
  }

  private setCurrentLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }


  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            this.googleAddress = {
              latitude: this.latitude,
              longitude: this.longitude,
              fullAddress: this.address,
            };
            console.log('gtaddress');
            this.googleAddressOutput.emit(this.googleAddress);
          } else {
            ("");
          }
        } else {
          ("");
        }
      }
    );
  }
}
